import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminServices } from '../services/admin.service';
import toast from 'react-hot-toast';

export const useUpdateAdmin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: adminServices.updateAdmin,
    onSuccess: () => {
      queryClient.invalidateQueries(['admins']);
      toast.success('Admin update successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to create admin');
    },
  });
};
